import { AppContext, CashLessService, form2, ImgUploadMutiplePC, sharedStyle } from "@pulseops/common"
import { SectionContent } from "@pulseops/submission/common"
import React from "react"
import { useTranslation } from "react-i18next"
import { StyleSheet, Text, TouchableOpacity, View } from "react-native"
import { APImportFileForm } from "./APApplyingPremiumForm"
import { Controller } from "react-hook-form"
import { pipe } from "fp-ts/function"
import { ZIO } from "@mxt/zio"
import { useLoading } from "@mxt/zio-react"

export const APImportFile = () => {
  const { t } = useTranslation()
  const [isLoading, bindLoader] = useLoading(false)
  const { showToast, showGlobalLoading } = React.useContext(AppContext.AppContextInstance)
  const { base } = form2.useForm(APImportFileForm.APImportFileFormType, {
    defaultValues: {
      attachmentFiles: []
    }
  })
  React.useEffect(() => { showGlobalLoading(isLoading) }, [isLoading])

  const onImportFile = async () => {
    const isValidForm = await base.trigger()
    if (isValidForm) {
      const formData = base.getValues()
      pipe(
        CashLessService.APImportFile(formData.attachmentFiles[0].file as Blob),
        ZIO.foldM(
          (error) => {
            showToast(t('message:MS990079'), 'error')
            return ZIO.fail(error)
          },
          (result) => {
            showToast(t('message:MS990066'), 'success')
            resetForm()
            return ZIO.succeed(result)
          }
        ),
        bindLoader,
        ZIO.unsafeRun({})
      )
    }
  }

  const resetForm = () => {
    base.reset({
      attachmentFiles: []
    })
  }
  return (
    <View style={sharedStyle.wrapper}>
      <SectionContent>
        <Text style={APImportStyles.fieldTitle}>{t("Import File")}</Text>
        <Text style={APImportStyles.fieldSubTitle}>
          {t("Attachment")}
          <Text style={APImportStyles.requiredText}> * </Text>
        </Text>
        <Controller
          control={base.control}
          name="attachmentFiles"
          render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
            <>
              <ImgUploadMutiplePC
                value={value as any[]}
                onChange={(val) => {
                  onChange(val)
                }}
                onBlur={onBlur}
                timeFormat={'DD/MM/YYYY HH:mm'}
                maxSizeFile={10}
                maxTotalFile={10}
                messageFormat={'TaskManagement:MSFormatUploadFileXLSX'}
                validExtensions={['XLS', 'XLSX']}
                messageMaxSize={'TaskManagement:MaxSizeFile10MB'}
                maxNumFile={1}
                takeAPicture={false}
                showFullFileName
                isFileDownload={false}
                errorMessage={'message:OB0075'}
              />
              {error && error.message && <Text style={APImportStyles.errorMessageText}>{error.message}</Text>}
            </>
          )}
        />
      </SectionContent>
      <View style={APImportStyles.buttonContainer}>
        <TouchableOpacity style={[sharedStyle.button, sharedStyle.btnRed]} onPress={() => onImportFile()}>
          <Text style={sharedStyle.textButtonRed}>{t('Import file')}</Text>
        </TouchableOpacity>
      </View>
    </View>
  )
}
const APImportStyles = StyleSheet.create({
  fieldTitle: {
    color: '#4F4F4F',
    fontSize: 16,
    fontWeight: 'bold',
    lineHeight: 20,
    marginBottom: 15
  },
  fieldSubTitle: {
    color: '#70777E',
    fontSize: 15,
    fontStyle: 'normal',
    fontWeight: '700'
  },
  requiredText: {
    color: '#ED1B2C',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center'
  },
  errorMessageText: {
    color: '#ED1B2C',
    fontSize: 11.25
  }
})